import toLower from 'lodash/toLower'
import type { PivotField } from '@ztechapps/common.contract'

/** Keeps the fields whose name contains the search text, ignoring letter case. */
export const filterPivotFields = (fields: PivotField[], search: string): PivotField[] =>
  fields.filter((field) => toLower(field.name).includes(toLower(search)))
